import ReactDOM from 'react-dom';
import './index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/auth/AuthContext';
import { LayoutProvider } from './hooks/layout/LayoutContext';
import { ApolloProvider } from '@apollo/client';
import { CookiesProvider } from 'react-cookie';
import { client } from './apollo-clients';
import { BrowserRouter as Router } from 'react-router-dom';

// Suppress ResizeObserver loop limit exceeded error
// This error is benign and occurs when ResizeObserver cannot deliver all observations within a single animation frame
// Reference: https://github.com/ant-design/ant-design/issues/24913
// This is a known browser issue, especially in Chrome, when ResizeObserver cannot process all observations in a single frame

// Method 1: Suppress the error in development
const resizeObserverErrorHandler = (e: ErrorEvent) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) {
      resizeObserverErr.style.display = 'none';
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.style.display = 'none';
    }
    e.stopPropagation();
    e.stopImmediatePropagation();
    return true;
  }
  return false;
};

window.addEventListener('error', resizeObserverErrorHandler);

// Method 2: Patch ResizeObserver to debounce notifications
// This prevents the error from occurring in the first place
const debounce = (callback: (...args: any[]) => void, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callback(...args), delay);
  };
};

if (window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super(debounce(callback, 20));
    }
  } as any;
}

ReactDOM.render(
  // <React.StrictMode>
  <CookiesProvider>
    <LayoutProvider>
      <ApolloProvider client={client}>
        <AuthProvider>  
          <Router>     
            <App />
          </Router>
        </AuthProvider>
      </ApolloProvider>
    </LayoutProvider>
  </CookiesProvider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
